import styled from "styled-components";
import {Carousel} from 'antd';
import {Image} from "../Image";

export default function CarouselImages(props: { imageUrls: Array<string>, loadingStyle?: any, imageStyle?: any, height: number }) {
    return (
        <Container {...props} style={{height: props?.height}}>
            <Carousel autoplay dots={props?.imageUrls?.length > 1} slidesToShow={1} centerPadding={'0px'} adaptiveHeight
                      centerMode={true} slidesToScroll={1}>
                {
                    props.imageUrls.map((item, index) => {
                        return (
                            <Item key={index.toString()}>
                                <ItemImg style={{...{height: props?.height}, ...(props?.imageStyle || {})}}
                                         loadingStyle={props?.loadingStyle || {
                                             width: "100%",
                                             height: (props?.height || "300px")
                                         }}
                                         src={item}/>
                            </Item>
                        )
                    })
                }
            </Carousel>
        </Container>
    )
}

const Container = styled.div`
  height: 300px;
  width: 100%;

  & .ant-carousel {
    width: 100%;
  }

  & .ant-carousel .slick-dots-bottom {
    justify-content: flex-end;
    margin: 0;
    bottom: 12px;
    right: 12px;
  }

  & .ant-carousel .slick-dots li {
    width: 8px;
    height: 8px;
    border-radius: 8px;
    border: 1px solid #ffffff;
    background-color: #727C8A;
  }

  & .ant-carousel .slick-dots li button {
    width: 8px;
    height: 8px;
    border-radius: 8px;
    background-color: transparent;
  }

  & .ant-carousel .slick-dots li.slick-active {
    background-color: ${props => props.theme.main};
  }
`;
const Item = styled.div`
`;
const ItemImg = styled(Image)`
  height: 300px;
  width: 100%;
  object-fit: cover;
`;